import { Flex } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import useAssuntosMensagens from "core/features/mensagens/hooks/useAssuntosMensagens";
import { AssuntoMensagemIcone } from "core/features/mensagens/typings";
import colors from "core/resources/theme/colors";
import {
  BsFillDropletFill,
  BsFillLightningFill,
  BsFillVolumeUpFill,
} from "react-icons/bs";
import { FaPenAlt } from "react-icons/fa";
import { IoBrushSharp } from "react-icons/io5";
import { MdOutlineSubject } from "react-icons/md";
import IconShadowSelectableButton from "ui/components/Button/IconShadowSelectableButton";

interface SelectAssuntoMensagemProps {
  onChange: ({ id, nome }: { id: string; nome: string }) => any;
  value: string;
  isInvalid?: boolean;
}

const CardSkeleton = () => <Skeleton h="90px" w="18%" rounded={16} />;

function SelectAssuntoMensagem({
  onChange,
  value,
  isInvalid,
}: SelectAssuntoMensagemProps) {
  const {
    data: assuntosMensagem,
    isLoading,
    isFetching,
  } = useAssuntosMensagens();

  const _isLoading = isLoading || isFetching;
  return (
    <Flex
      flexWrap="wrap"
      gridGap={4}
      minH="40px"
      borderWidth={1}
      w="100%"
      borderColor={isInvalid ? "red" : "transparent"}
    >
      {_isLoading ? (
        <>
          <CardSkeleton />
          <CardSkeleton />
          <CardSkeleton />
          <CardSkeleton />
          <CardSkeleton />
        </>
      ) : null}

      {!_isLoading && assuntosMensagem?.length
        ? assuntosMensagem.map((assunto) => (
            <IconShadowSelectableButton
              key={assunto.id}
              selected={value === assunto.id}
              fontSize={12}
              text={assunto.nome}
              Icon={mapIconeToComponent(assunto.icone)}
              value={assunto.id}
              onChange={(id) => {
                onChange({ id, nome: assunto.nome });
              }}
              color={mapIconeToColor(assunto.icone)}
              iconSize={18}
              buttonProps={{
                h: "90px",
                w: "15.2%",
                paddingTop: 1,
                paddingBottom: 1,
              }}
            />
          ))
        : null}
    </Flex>
  );
}

const mapIconeToComponent = (icone: AssuntoMensagemIcone) => {
  switch (icone) {
    case AssuntoMensagemIcone.Caneta:
      return FaPenAlt;
    case AssuntoMensagemIcone.Gota:
      return BsFillDropletFill;
    case AssuntoMensagemIcone.Raio:
      return BsFillLightningFill;
    case AssuntoMensagemIcone.Som:
      return BsFillVolumeUpFill;
    case AssuntoMensagemIcone.Vassoura:
      return IoBrushSharp;
    default:
      return MdOutlineSubject;
  }
};

const mapIconeToColor = (icone: AssuntoMensagemIcone) => {
  switch (icone) {
    case AssuntoMensagemIcone.Caneta:
      return colors.purple;
    case AssuntoMensagemIcone.Gota:
      return colors.cyan;
    case AssuntoMensagemIcone.Raio:
      return colors.yellow;
    case AssuntoMensagemIcone.Som:
      return colors.blue;
    case AssuntoMensagemIcone.Vassoura:
      return colors.pink;
    default:
      return colors.blue;
  }
};

export default SelectAssuntoMensagem;
